import React, { useContext } from "react";
import Marquee from "react-fast-marquee";

import "./Skills.css";
import Avatar from "./Avatar";

function MarqueeCom({ MarqueeData }) {
  console.log(MarqueeData, "MarqueeData in MarqueeCom");
  return (
    <div className="skills">
      <div className="skillsHeader"></div>
      <div className="skillsContainer">
        <div className="skill--scroll">
          {MarqueeData && (
            <Marquee
              gradient={false}
              speed={100}
              pauseOnHover={false}
              pauseOnClick={true}
              delay={0}
              play={true}
              direction="left"
            >
              {MarqueeData &&
                MarqueeData.length > 0 &&
                [...MarqueeData, ...MarqueeData].map((user, id) => (
                  <div className="skill--box" key={id}>
                    {user.photoURL ? (
                      <img
                        src={user.photoURL}
                        alt="user"
                        width="100%"
                        height="100%"
                        style={{
                          filter:
                            "drop-shadow(0px 0px 10px rgba(128,128,128,0.75))",
                        }}
                      />
                    ) : (
                      <Avatar Name={user.email} />
                    )}
                  </div>
                ))}
            </Marquee>
          )}
        </div>
      </div>
    </div>
  );
}

export default MarqueeCom;
